"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypeInformation = exports.getDomainInformation = void 0;
const getDomainInformation = (chainId, verifyingContract) => {
    return {
        name: 'EPNS COMM V1',
        chainId,
        verifyingContract,
    };
};
exports.getDomainInformation = getDomainInformation;
const getTypeInformation = (action) => {
    if (action === 'Create_user') {
        return {
            Data: [{ name: 'data', type: 'string' }],
        };
    }
    return '';
};
exports.getTypeInformation = getTypeInformation;
//# sourceMappingURL=signature.js.map